/**
 * Phase 9.8 (2026-05-24) — hoisted from VoicePanel.tsx so it can be shared
 * with ToolHistoryChip.tsx (also added in Phase 9.8). No behavioral change.
 *
 * Returns a short HH:MM-style time label (locale-aware) for voice history
 * rows. Empty string on invalid/zero timestamps.
 */
export function formatVoiceTimestamp(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return '';
  return new Date(ms).toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });
}
